import { BillingState } from '../state';
import { BillingAction, BillingActions } from '../actions/billing.action';

const initialState: BillingState = {
  sync: false
};

const billingReducer = (state: BillingState = initialState, action: BillingAction): BillingState => {
  switch (action.type) {
    case BillingActions.RefreshSubscriptionStatusSucceeded:
    case BillingActions.SyncSubscriptionStatusSucceeded:
      return {
        ...state,
        sync: true
      };
    default:
      return state;
  }
};

export default billingReducer;
